import axios from "axios";
import { apiState } from "./apiState";
import { getRequestContext } from "./apiUtilities";
import Constants from "../constants";
import HttpStatusCode from "@/shared/ts/httpStatusCode";
import { DisconnectedCallService } from "./disconnectedCallService";

export const configureAxios = function () {

    axios.defaults.xsrfCookieName = "XSRF-FORM-TOKEN";
    axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
    axios.defaults.withCredentials = true;
    
    axios.get("/account/token")
         .catch(() => console.error("Could not get CSRF token"));

    axios.interceptors.request.use(async config => {
        let variableSubstitutionRequired = false;

        if (config.url != null) {
            variableSubstitutionRequired = requestRequiresVariableSubstitution(config.url);
        }

        if (!variableSubstitutionRequired) {
            return config;
        }

        if (!apiState.isInitialCallCompleted) {
            await apiState.initialCallCompletedPromise;
        }

        const requestContext = getRequestContext();
        config.url = requestContext.verifyUrl(config.url);

        return config;
    });

    axios.interceptors.request.use(async config => {
        if (DisconnectedCallService.isDisconnected()) {
            const isSuppressed = await DisconnectedCallService.isSuppressed(config.url);

            if (isSuppressed) {
                const controller = new AbortController();
                const source = axios.CancelToken.source();
                source.cancel(config.url);
                config.cancelToken = source.token;
                controller.abort();
                return config;
            }
        }

        return config;
    });

    axios.interceptors.response.use(
        response => {
            return response;
        },
        async error => {
            if (axios.isCancel(error) && DisconnectedCallService.isDisconnected()) {
                const disconnectedCallInfo = await DisconnectedCallService.getDisconnectedCallInfo(error.message);
                const data = disconnectedCallInfo?.getData() ?? {};

                return Promise.resolve({
                    data: data,
                    status: HttpStatusCode.Ok,
                    statusText: "OK",
                    headers: {},
                    config: {},
                    request: {}
                });
            }

            if (error.response.status !== HttpStatusCode.Forbidden) {
                return Promise.reject(error);
            }

            window.location.href = Constants.LoginResouce;
        }
    )
}

function requestRequiresVariableSubstitution(url: string): boolean {
    const regex = /\{[^}]*\}/g;
    return regex.test(url);
}
